'use strict';

/**
 * Created by MRQ on 2016/1/11.
 */
angular.module('editNewspaperServiceModule', [
    'draftCorrelationModule',
    'cancelSignedModule',
    'newspaperRetractDraftModule',
    'editNewspaperRejectionModule',
    'initDataNewspaperServiceModule',
    'editCenNewspaperProcessRecordingModule',
    'editCenNewspaperTextDesignationModule',
    'newsPaperPagePreviewModule',
    'editNewspapaerSignedZPInfoModule',
    'manualUploadModule',
    'editNewspaperBackManuscriptModule',
    'acrossAlertModule'
])
    .factory('editNewspaperService', ['$modal', '$q', '$filter', 'trsHttpService', 'localStorageService', 'editingCenterService', 'editcenterRightsService', 'modalDialog', 'trsspliceString', '$state', function($modal, $q, $filter, trsHttpService, localStorageService, editingCenterService, editcenterRightsService, modalDialog, trsspliceString, $state) {
        var cacheOpenedPanel = {};

        return {
            collectDraft: function(scope, methodname) {
                var array = trsspliceString.spliceString(scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: methodname,
                    MetaDataIds: array,
                };
                const chnlDocIds = scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, scope.requestData).then(function(data){
                    modalDialog.alertType('', '确认收藏稿件?', 'ask', true, function() {
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType('收藏成功', '', 'success', false, function() {
                                scope.requestData();
                            });
                        });
                    });
                });
            },
            archive: function(selectedArray, success, fail) {
                const chnlDocIds = selectedArray.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, fail).then(function(data) {
                    modalDialog.inputModel('归档', '归档意见（可选）', function (content) {
                        modalDialog.confirmModal('归档', '确认归档所选稿件', function () {
                            var params = {
                                serviceid: 'mlf_paper',
                                methodname: 'doGuiDang',
                                Option: content,
                                SrcDocIds: trsspliceString.spliceString(selectedArray, 'METADATAID', ','),
                                SrcBanMianIds: trsspliceString.spliceString(selectedArray, 'CHNLID', ','),
                            };
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                success();
                            }, function(){
                                fail();
                            });
                        });
                    });
                });
            },
            draftCorrelationViews: function(id, paperid, position) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/manuscriptCorrelation/manuscript_correlation_tpl.html',
                    windowClass: 'edit-newspaper-draft-correlation',
                    backdrop: false,
                    controller: 'draftCorrelationCtrl',
                    resolve: {
                        params: function() {
                            return {
                                'SrcDocId': id,
                                'PaperId': paperid,
                                'position': position
                            };
                        }
                    }
                });
                return modalInstance.result.then(function(result) {

                });
            },
            // 撤稿，取消签发，待用
            cancelSignedViews: function(transferData, successFn, cancel) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/cancelSigned/cancelSigned_tpl.html',
                    windowClass: 'edit-newspaper-cancel-signed',
                    backdrop: false,
                    controller: 'cancelSignedCtrl',
                    resolve: {
                        params: function() {
                            return transferData;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    if (result === false) {
                        if (angular.isFunction(cancel)) {cancel();}
                        return;
                    }
                    successFn(result);
                });
            },
            // 大样审阅流程记录
            processRecording: function(item) {
                $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/ProcessRecording/ProcessRecording_tpl.html',
                    windowClass: 'editCompiledobjTime',
                    backdrop: false,
                    controller: 'editCenNewspaperProcessRecordingCtrl',
                    resolve: {
                        params: function() {
                            return item;
                        }
                    }
                });
            },
            // 撤稿
            retractDraft: function() {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/retractDraft/retractDraft_tpl.html',
                    windowClass: 'newspaper-retractDraft-windows',
                    backdrop: false,
                    controller: 'newspaperRetractCtrl',
                });
                modalInstance.result.then(function(result) {

                });
            },
            // 上版or转版
            changeLayoutDraft: function(transferData, success, cancel) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/shangbanWindows/shangbanWindows_tpl.html',
                    windowClass: 'newspaper-shangban-windows',
                    controller: 'ediCtrNewspaperShangbanCtrl',
                    resolve: {
                        transferData: function() {
                            return transferData;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    if (result == false) {
                        cancel();
                    } else {
                        success(result);
                    }
                });
            },
            // 整版转版
            changeAllLayoutDraft: function(transferData, success, cancel) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/changeAllLayout/changeAllLayout.html',
                    windowClass: 'newspaper-change-allLayout',
                    controller: 'changeAllLayoutCtrl',
                    resolve: {
                        transferData: function() {
                            return transferData;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    if (result == false) {
                        if (cancel) {
                            cancel();
                        }
                    } else {
                        success(result);
                    }
                });
            },
            // 退稿
            rejectionDraft: function(transferData, success, fail) {
                const ChnlDocIds = transferData.item.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(ChnlDocIds, fail).then(function(data){
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/newspaper/alertViews/rejection/rejection.html',
                        windowClass: 'newspaper_rejection',
                        controller: 'editNewspaperRejectionCtrl',
                        resolve: {
                            params: function() {
                                return transferData;
                            }
                        }
                    });
                    modalInstance.result.then(function(result) {
                        if (result === 'success') {
                            success(result);
                        } else {
                            fail();
                        }
                    });
                });
            },
            newspaperBackManuscript: function(transferData, success, fail) {
                const ChnlDocIds = transferData.items.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(ChnlDocIds, fail).then(function(data){
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/newspaper/service/backManuscript/backManuscript_tpl.html',
                        windowClass: 'newsBackManuscript',
                        controller: 'editNewspaperBackManuscriptCtrl',
                        resolve: {
                            params: function() {
                                return transferData;
                            }
                        }
                    });
                    modalInstance.result.then(function(result) {
                        if (result === 'success') {
                            success(result);
                        } else {
                            fail();
                        }
                    });
                });
            },
            queryCurrSite: function(siteid) {
                var params = {
                    'serviceid': 'mlf_paperset',
                    'methodname': 'findPaperById',
                    'SiteId': siteid
                };
                var deferred = $q.defer();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    deferred.resolve(data);
                });
                return deferred.promise;
            }, // 导出稿件
            exportDraft: function(metaDataIds) {
                var params_1 = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportWordFile',
                    MetaDataIds: metaDataIds
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params_1, 'post')
                    .then(function(data) {
                        window.open(data);
                    });
            },
            // 签发照排方法(停用弹窗)
            stopSignZp: function(item, success, fail, cancel, options) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/signedZP/signedZP_tpl.html',
                    windowClass: 'newspaper_signedZP',
                    controller: 'editNewspapersignedZPCtrl',
                    resolve: {
                        item: function() {
                            return item;
                        },
                        options: function() {
                            return options;
                        }
                    }
                });
                modalInstance.result.then(function(result, data) {
                    if (result === false) {
                        if (angular.isFunction(cancel)) {cancel();}
                        return;
                    }
                    if (result === 'success') {
                        success(result);
                    } else {
                        setTimeout(function() {
                            fail(result);
                        }, 500);
                    }
                });
            },
            // 签发照排方法(启用弹窗)
            useSignZP: function(item, success, fail, cancel, options) {
                options = options || {};
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/useSignedZP/useSignedZP_tpl.html',
                    windowClass: 'newspaper_useSignedZP',
                    controller: 'editNewspaperUseSignedZPCtrl',
                    size: options.isFromResourceCenter ? '900' : '630',
                    resolve: {
                        item: function() {
                            return item;
                        }, 
                        options: function() {
                            return options;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (result === false) {
                        if (angular.isFunction(cancel)) {cancel();}
                        return;
                    }
                    if (result === 'success') {
                        success(result);
                    } else {
                        setTimeout(function() {
                            fail(result);
                        }, 500);
                    }
                });
            },

            /**
             * [singZpInfo description]签发照排排重信息
             * @param  {[obj]} result        [description]排重返回信息
             * @param  {[obj]} success      [description]
             * @param  {[obj]} cancel      [description]
             * @return {[null]}               [description]
             */
            singZpInfo: function(result, success, cancel) {
                var options = {
                    params: result.params,
                    callback: function(params, array) {
                        params.IsPaiChong = false;
                        params.SrcDocIds = [];
                        for (var i = 0; i < array.length; i++) {
                            if (array[i].DOC) {
                                params.SrcDocIds.push(array[i].DOC.METADATAID);
                            }
                        }
                        params.SrcDocIds = params.SrcDocIds.join(',');
                    }
                };
                editingCenterService.issuedByForce(result.errorData, options).then(function(result) {
                    if (result) {
                        success(result);
                        return;
                    }
                    cancel && cancel();
                });
            },

            /**
             * [textDesignation description] 评审意见弹窗
             * @param  {[type]}  id              [description] 大样id
             * @param  {[type]}  path            [description] 大样路径
             * @param  {Boolean} hasConfirmRight [description] 是否有确认通过的权限
             * @param  {[type]}  success         [description]
             * @return {[type]}                  [description]
             */
            textDesignation: function(id, path, hasConfirmRight, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/textDesignation/textDesignation_tpl.html',
                    windowClass: 'edit-newspaper-textDesignation',
                    controller: 'editCenNewspaperTextDesignationCtrl',
                    resolve: {
                        item: function() {
                            return {
                                'id': id,
                                'path': path,
                                'hasConfirmRight': hasConfirmRight
                            };
                        }
                    }

                });
                modalInstance.result.then(function(result) {
                    success();
                });
            },

            /**
             * /[initNewspaperEdit][description]初始化报纸编辑页面
             * @return {[type]} [description]
             */
            initNewspaperEdit: function() {
                var newspaperpath = {
                    1: 'newspapertext',
                    2: 'newspaperpic'
                };
                return newspaperpath;
            },

            /*
             *[initNewspaperPreview][description] 初始化预览页面
             */
            initNewspaperPreview: function() {
                var preview = {
                    1: 'newspaperNewsPreview',
                    2: 'newspaperAtlasPreview'
                };
                return preview;
            },

            /**
             * [initNewspaperRule][description]  初始化报纸按钮权限
            */
            initNewspaperRule: function() {
                var paperRule = {
                    jrg: '0',
                    sbg: '1',
                    dyg: '2',
                    yqg: '3',
                    gdg: '4',
                    dxd: '5'// 待修订
                };
                return paperRule;
            },
            cacheOpenedPanel: function(key, value) {
                cacheOpenedPanel[key] = value;
            },
            getCacheOpenedPanel: function(key) {
                return cacheOpenedPanel[key];
            },

            /**
             * [paperId description]
             * @param   {[type]}  paperId  [paperId description]
             * @param   {[type]}  item     [item description]
             * @param   {[type]}  success  [success description]
             * @return  {[type]}           [return description]
             */
            manualUpload: function(paperId, item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/service/manualUpload/manualUpload_tpl.html',
                    windowClass: 'newspaper_manualUpload',
                    controller: 'manualUploadCtrl',
                    backdrop: false,
                    keyboard: false,
                    resolve: {
                        paperId: function() {
                            return paperId;
                        },
                        item: function() {
                            return item;
                        }
                    }
                });
                return modalInstance.result.then(function(data) {
                    if (data) {
                        success(data);
                    }
                });

            },

            /*
            * 总字数处理
            * */
            getWordNum: function(data) {
                var wordarr = Array.from({length: data.length}).map(() => ({selcetedWord: 0, wordAllCount: 0}));
                data.map((item, index) => {
                    var wordNum = 0;
                    item.DOCUMENTS.map((obj) => {
                        wordNum = wordNum + Number(obj.DOCWORDSCOUNT);
                    });
                    wordarr[index].wordAllCount = wordNum;
                });
                return wordarr;
            },

            /**
             * [screenFilter description]折叠列表模式下数据循环提取
             *
             * @param   {[type]}  list  [list description] 列表，从中提取版面
             * @param   {[type]}  namekey  [list description] 过滤人物名称
             *
             * @return  {function}      [return description]
             */
            extractParameters: function(list, namekey) {
                namekey = namekey || {
                    namekey: 'TRUENAME',
                    valuekey: 'CRUSER',
                    title: '创建人'
                };
                var nameArr = [{
                    name: '全部' + namekey.title,
                    value: ''
                }];
                for (var i = 0; i < list.length; i++) {
                    for (var j = 0; j < list[i].DOCUMENTS.length; j++) {
                        var item = list[i].DOCUMENTS[j];
                        nameArr.push({
                            name: item[namekey.namekey],
                            value: item[namekey.valuekey]
                        });
                    }
                }
                return {
                    nameArr: nameArr,
                };
            },

            /**
             * [list description]大列表模式下数据循环提取
             *
             * @param   {[type]}  list     [list description]
             * @param   {[type]}  namekey  [namekey description]
             *
             * @return  {[type]}           [return description]
             */
            extractParametersList: function(list, namekey) {
                namekey = namekey || {
                    namekey: 'TRUENAME',
                    valuekey: 'CRUSER',
                    title: '创建人'
                };
                var filterReviseItem = [];
                var nameArr = [{
                    name: '全部' + namekey.title,
                    value: ''
                }];
                list.forEach(function(item) {
                    if (item.PAPERSTATUSNAME !== '待修订') {
                        filterReviseItem.push(item);
                    }
                    nameArr.push({
                        name: item[namekey.namekey],
                        value: item[namekey.valuekey]
                    });
                });
                return {
                    filterReviseItem: filterReviseItem,
                    nameArr: nameArr
                };
            },

            /**
             * [paperId description]
             *
             * @param   {[type]}  paperId  [paperId description]
             * @param   {[type]}  isZP     [isZP description]
             *
             * @return  {[type]}           [return description]
             */
            screenFilter: function(paperId, isZP) {
                var defer = $q.defer();
                var banMianArr = [{
                    CHNLDESC: '全部版面',
                    CHANNELID: ''
                }];
                var params = {
                    methodname: isZP ? 'queryZhaoPaiBanMians' : 'queryCaiBianBanMians',
                    serviceid: 'mlf_paper',
                    PaperId: paperId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    // var banMianArr = $filter('unique')(data.DATA, 'CHNLDESC');
                    banMianArr = banMianArr.concat(data);
                    defer.resolve(banMianArr);
                });
                return defer.promise;
            },

            /**
             * [draft description]
             *
             * @param   {[type]}  options           [title description]
             * @param   {[type]}  success         [success description]
             * @param   {[type]}  fail            [fail description]
             *
             * @return  {function}                [return description]
             */
            draft: function(options, success, fail) {
                const chnlDocIds = options.selectedArray.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, fail).then(function(data){
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/draft/draft_tpl.html',
                        windowClass: 'myManuscript-draft',
                        backdrop: false,
                        controller: 'iWoDraftCtrl',
                        resolve: {
                            incomeData: function() {
                                return options;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                });
            },

            // 报纸全部 创建人
            newspaperEntire: function() {
                var newspaperEntireJsons = [{
                    name: '全部',
                    value: ''
                }, {
                    name: '标题',
                    value: 'docTitle'
                }, {
                    name: '正文',
                    value: 'Content'
                }, {
                    name: '作者',
                    value: 'AuthorTruename'
                }];
                return newspaperEntireJsons;
            },

            /**
             * [liebiaoListItemCache description]列表模式下缓存数据，为了在详情页使用上一篇、下一篇
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            liebiaoListItemCache: function(data) {
                var cachePreviewMetadataid = [];
                angular.forEach(data, function (data) {
                    cachePreviewMetadataid.push({
                        METADATAID: data.METADATAID,
                        PAPERSTATUSNAME: data.PAPERSTATUSNAME,
                        NEWSPAPERTYPE: 1,
                    });
                });
                localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
            },

            /**
             * [items description] 取消签发时跨版转版的稿件提示
             *
             * @param  {[type]}  items   [items description] 跨版转版稿件
             *
             * @return  {[type]}   [return description]
             */
            acrossAlert: function(items) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/newspaper/alertViews/acrossAlert/acrossAlert_tpl.html',
                    windowClass: 'edit-newspaper-draft-correlation',
                    backdrop: false,
                    controller: 'acrossAlertCtrl',
                    resolve: {
                        items: function() {
                            return items;
                        }
                    }
                });
                return modalInstance.result;
            },

            /**
             * [rights description] 获取版面权限，用于判断是否有某个版面的权限
             *
             * @param  {[type]}  rights   [rights description]
             * @param  {[type]}  channelId   [channelId description]
             * @param  {[type]}  paperId   [paperId description]
             * @param  {[type]}  type   [type description]
             *
             * @return  {[type]}   [return description]
             */
            getBMRights: function(rights, channelId, paperId, type) {
                var defer = $q.defer();
                if (rights[channelId]) {
                    defer.resolve(rights[channelId]);
                } else {
                    editcenterRightsService.initNewspaperListBtn(type, paperId, channelId).then(function (data) {
                        rights[channelId] = data;
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            },

            /**
             * [selectedArray description] 获取版面权限，在勾选稿件时使用
             *
             * @param  {[type]}  data   [selectedArray description] data对象，取参
             * @param  {[type]}  paperid   [paperid description] 报纸id
             * @param  {[type]}  channelId   [channelId description] 版面id
             * @param  {[type]}  type   [type description] 稿件位于哪一阶段
             *
             * @return  {[type]}   [return description]
             */
            getAllBMRights: function(data, paperid, channelId, type) {
                if (data.BanMian.selectedBanMian.CHANNELID) { // 代表当前选中某一具体版面，无需再去请求权限
                    return;
                }
                var defer = $q.defer();
                if (!data.selectedArray.length) {
                    defer.resolve(data.AllBMRights[type]);
                } else {
                    if (data.AllBMRights[channelId]) {
                        defer.resolve(editcenterRightsService.permissionIntersection(data.selectedArray, data.AllBMRights));
                    } else {
                        editcenterRightsService.initNewspaperListBtn(type, paperid, channelId).then(function (rights) {
                            data.AllBMRights[channelId] = rights;
                            defer.resolve(editcenterRightsService.permissionIntersection(data.selectedArray, data.AllBMRights));
                        });
                    }
                }
                return defer.promise;
            }
        };
    }]);
